// 蛋白质互作网络图
import ChartTemplate from '../ChartTemplate';
import { userFileStream } from '@/plugins/api';

export default {
  extends: ChartTemplate,
  props: {
    formButtons: {
      default: function () {
        return [{ code: 'download', name: '下载', click: () => this.onDownload() }]
      }
    }
  },
  data () {
    return {
      extCPT: () => import('./ExtendComponent.vue'),
      extCPTValue: false,
      clickPoint: null
    }
  },
  computed: {
    extCPTProps () { return { point: this.clickPoint } }
  },
  methods: {
    initOptionAfter () {
      this.addEventAfterSetOptions();
      let option = { plotOptions: { series: { point: { events: { click: this.pointClick } } } } }
      this.Utility.deepMerge(this.chartOption, option);
    },

    // 下载详细文件
    onDownload () {
      let dto = this.Utility.clone(this.dataSourceParam);
      dto.toolTask.resultFile = 'output_ann.xlsx';
      userFileStream(dto);
    },

    // ============================ 点的click事件
    pointClick (e) {
      this.clickPoint = e.point;
      this.extCPTValue = true;
    },
    onUpdatePoint (radius, fillColor) {
      let option = { marker: { radius: radius }, color: fillColor };
      this.clickPoint.update(option, false); // 不需要重新渲染
      this.clickPoint.select(true); // 选中再取消可以将颜色显示上去
      this.clickPoint.select(false);
      this.extCPTValue = false;
    },

    // ================ 计算点的大小
    processPoint () {
      let links = this.chartOption.series[0].data;
      let map = {};
      links.forEach(link => {
        let l1 = link[0], l2 = link[1];
        if (map[l1]) map[l1] = map[l1] + 1;
        else map[l1] = 1;
        if (map[l2]) map[l2] = map[l2] + 1;
        else map[l2] = 1;
      })
      for (let k in map) if (map[k] == 1) delete map[k]
      return map;
    },
    // ================= 修改原点大小
    addEventAfterSetOptions () {
      let points = this.processPoint();
      this.Highcharts.addEvent(this.Highcharts.seriesTypes.networkgraph, 'afterSetOptions',
        (e) => {
          let nodes = [];
          e.options.data.forEach((link) => {
            let l1 = link[0];
            if (points[l1]) nodes.push({ id: l1, marker: { radius: 4 + points[l1] - 1 } });
          })
          e.options.nodes = nodes;
        }
      )
    }

  }
}